import React, { useState, useRef, useEffect } from 'react';

const CustomSelect = ({ name, value, onChange, children, className, style, required }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Parse <option> children into flat list
  const options = [];
  React.Children.forEach(children, child => {
    if (!child || !React.isValidElement(child)) return;
    const val = child.props.value !== undefined ? String(child.props.value) : '';
    const lbl = child.props.children ?? val;
    options.push({ value: val, label: lbl });
  });

  const currentVal  = value !== undefined && value !== null ? String(value) : '';
  const selectedOpt = options.find(o => o.value === currentVal);
  const displayLabel = selectedOpt?.label ?? '';

  const handleSelect = (optValue) => {
    onChange({ target: { name, value: optValue } });
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    document.addEventListener('touchstart', close);
    return () => {
      document.removeEventListener('mousedown', close);
      document.removeEventListener('touchstart', close);
    };
  }, [open]);

  const cls = className || 'form-select';

  return (
    <div ref={ref} style={{ position: 'relative', ...(style || {}) }}>
      {/* Trigger */}
      <div
        onClick={() => setOpen(o => !o)}
        className={cls}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          cursor: 'pointer', userSelect: 'none', gap: 8,
        }}
      >
        <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {displayLabel}
        </span>
        <svg
          width="12" height="12" viewBox="0 0 20 20" fill="currentColor"
          style={{ flexShrink: 0, opacity: 0.55, transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.15s' }}
        >
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>

      {/* Dropdown list */}
      {open && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 99999,
          background: '#ffffff', border: '1.5px solid #e0e4ef', borderRadius: 10,
          boxShadow: '0 8px 32px rgba(10,14,26,0.18)',
          overflow: 'hidden', maxHeight: 260, overflowY: 'auto',
        }}>
          {options.map((opt, i) => {
            const isSelected = opt.value === currentVal;
            return (
              <div
                key={i}
                onClick={() => handleSelect(opt.value)}
                style={{
                  padding: '11px 14px',
                  cursor: 'pointer',
                  background: isSelected ? '#0077b6' : '#fff',
                  color: isSelected ? '#fff' : '#0d1117',
                  fontSize: 13,
                  fontWeight: isSelected ? 600 : 400,
                  borderBottom: i < options.length - 1 ? '1px solid #f3f4f6' : 'none',
                  transition: 'background 0.1s',
                }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#f0f6fb'; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = '#fff'; }}
              >
                {opt.label}
              </div>
            );
          })}
        </div>
      )}

      {required && !currentVal && (
        <input
          type="text"
          required
          value=""
          onChange={() => {}}
          tabIndex={-1}
          style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: 0, opacity: 0, pointerEvents: 'none' }}
        />
      )}
    </div>
  );
};

export default CustomSelect;
